import module from 'viaticos/module.js'
import template from './template.html'
import * as moment from 'moment'
import { isDate } from 'lodash'

export class ViaticosMisviaticosComponent {
  busqueda

  constructor ($location, $state) {
    this.$location = $location
    this.$state = $state
  }

  $onChanges (changes) {
    if (changes.busqueda && (!this.busqueda || !isDate(this.busqueda.fechaFinal))) {
      this.busqueda = {
        fechaInicial: changes.busqueda.currentValue.fechaInicial || moment().subtract(1, 'months').toDate(),
        fechaFinal: moment().add(1, 'months').toDate(),
      }
    }
  }

  buscar () {
    this.$location.search({
      fechaFinal: moment(this.busqueda.fechaFinal).format('YYYY-MM-DD'),
    })
  }

  solicitar () {
    this.$state.go('.solicitar')
  }
}

module.component('viaticosMisviaticos', {
  controller: ViaticosMisviaticosComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/misviaticos/component.js